import './WizardContentPane.scss';
import React, { Component } from 'react';

export default class RegistrationContentPane extends Component {
    render() {
        return this.props.children;
    }
}